import script from "./SogDatePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogDatePicker.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__